// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"4d9f3dec","106":"43165bc0","734":"252627b9","775":"86dd1fea","878":"294fc6fd"}[chunkId] + ".css";
};